module.exports = __webpack_public_path__ + "img/kiosk-place-de-la-cite-map.af68a5c8.webp";